import styled from 'styled-components';
import H4 from 'UIComponents/elements/headings/H4';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { GRID_BREAKPOINT_LARGE } from 'HubStyleTokens/sizes';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ContainerPushDown = styled.div.withConfig({
  displayName: "AcademyInfoFooter__ContainerPushDown",
  componentId: "sc-1fa3vnt-0"
})(["padding-bottom:", "px;@media (min-width:", "){padding-top:40px;}"], props => props.bottomPadding, GRID_BREAKPOINT_LARGE);
const AcademyInfoFooter = ({
  inModal
}) => /*#__PURE__*/_jsx(ContainerPushDown, {
  bottomPadding: inModal ? 20 : 80,
  className: "container",
  children: /*#__PURE__*/_jsx("div", {
    className: "row p-y-9",
    children: /*#__PURE__*/_jsxs("div", {
      className: "col-xs-12",
      children: [/*#__PURE__*/_jsx(H4, {
        className: "text-center has--on-dark",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.academyBlurb.title"
        })
      }), /*#__PURE__*/_jsx("p", {
        className: "text-center has--on-dark m-bottom-6",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "learningCenter.certification.academyBlurb.body"
        })
      })]
    })
  })
});
export default AcademyInfoFooter;